import React from "react";
import LegalPage from "@/components/LegalPage";

export default function PrivacyPolicy() {
  return <LegalPage namespace="privacy" testId="privacy-policy-page" />;
}
